import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector, checkUserToken } from '../../Auth/authSlice';
import PrivateRoute from '../PrivateRoute';
import Dashboard from '../../DDADPanel/Dashboard/index';
import FrontAllProcess from '../../DDADPanel/Process/index';
import kivProcess from '../../DDADPanel/Process/kiv/index';
import FrontViewAllUser from '../../DDADPanel/ViewAllUser/index';
import FrontViewProcess from '../../DDADPanel/ViewAllProcess/index';
import Notification from '../../DDADPanel/Notification/index';
import DocumentVerification from '../../DocumentVerification/DocumentVerification';
import DocumentVerification2 from '../../DocumentVerification/DocumentVerification2';
import DocumentSignature from '../../DocumentSignature/index';
import AddDocument from '../../DDADPanel/AddDocument/index';
import TakeActionNotification from '../../DDADPanel/TakeActionNotification/index';
import ability from '../../../config/ability';
import DocumentEditor from '../../DocumentEditor/DocumentEditor';
import AddMultipleProcessDocument from '../../DDADPanel//AddMultipleProcessDocument';
import CollaborateDocument from '../../DDADPanel/CollaborateDocument/index';
import CommonEditor from '../../CollaborationDocumentEditor/CommonEditor';

export default function DDADRoutes() {

  const dispatch = useDispatch();
  let history = useHistory();

  const { isLoggedIn, user } = useSelector(
    authSelector
  );

  useEffect(() => {
    dispatch(checkUserToken()).then((res) => {
      if (res.message === "unauthorized") { history.push('/'); }
    }).catch((err) => {
      // console.log("err=>   ", err)
    });
  }, [])


  return (
    <>
      {user.userType == "DD's & AD's"
        ? <>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/all-process" component={FrontAllProcess} exact />
          <PrivateRoute path="/kiv-process" component={kivProcess} exact />
          <PrivateRoute path="/view-all-users" component={FrontViewAllUser} exact />
          <PrivateRoute path="/view-process" component={FrontViewProcess} exact />
          <PrivateRoute path="/view-all-notification" component={Notification} exact />
          <PrivateRoute path="/verify-document" component={DocumentVerification} exact />
          <PrivateRoute path="/verify-document2" component={DocumentVerification2} exact />
          <PrivateRoute path="/use-this-document" component={AddMultipleProcessDocument} exact />
          <PrivateRoute path="/document-editor" component={DocumentEditor} exact />
          <PrivateRoute path="/document-signin" component={DocumentSignature} exact />
          <PrivateRoute path="/add-document" component={AddDocument} exact />
          <PrivateRoute path="/take-action-notification" component={TakeActionNotification} exact />
          <PrivateRoute path="/draft-document" component={CollaborateDocument} exact />
          <PrivateRoute path="/new-document" component={CommonEditor} exact />
        </>
        : <Redirect to="/login" />
      }

    </>
  );
}


